import { Component } from '@angular/core';

@Component({
    selector: 'accordion-component',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.css']
})
export class AccordionComponent {}